import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type { AttendanceReviewDecision, AttendanceReviewListParams } from "@membentry/shared-types";
import { ATTENDANCE_REVIEW_QUERY_KEY, CLUB_DAILY_SUMMARY_QUERY_KEY, attendanceReviewQueryKey } from "./queryKeys";
import { TODAY_CLUB_ENTRIES_QUERY_KEY } from "../clubs/queryKeys";

/** Owner-only list of offline scans the server could not accept on its own. */
export function useAttendanceReviewListQuery(
  client: AxiosInstance,
  params: AttendanceReviewListParams = {},
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: attendanceReviewQueryKey(params),
    queryFn: async () => {
      const { getAttendanceReviewList } = await import("@membentry/shared-api");
      return getAttendanceReviewList(client, params);
    },
    enabled: options?.enabled !== false,
  });
}

export function useReviewAttendanceEventMutation(client: AxiosInstance) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ eventId, decision }: { eventId: string; decision: AttendanceReviewDecision }) => {
      const { reviewAttendanceEvent } = await import("@membentry/shared-api");
      return reviewAttendanceEvent(client, eventId, decision);
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [ATTENDANCE_REVIEW_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [CLUB_DAILY_SUMMARY_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [TODAY_CLUB_ENTRIES_QUERY_KEY] });
    },
  });
}
